export const accountTypeInfo = {
  taAccounts: {
    system: "TA",
    payloadKey: "taGroupIds",
    payloadValue: (allFormData) =>
      allFormData ? allFormData.map(({ groupId }) => groupId) : [],
    formDataToStringKey: ({ groupId }) => `ta-g${groupId}`,
    hasAccountsKey: "investorTaOnly",
  },
  tracAccounts: {
    system: "TRAC",
    payloadKey: "planList",
    payloadValue: (allFormData) => allFormData ?? [],
    formDataToStringKey: (formData) =>
      `trac-i${formData.icuID}_pa${formData.participantID}_pl${formData.planID}`,
    hasAccountsKey: "investorTracOnly",
  },
};

export const accountTypeKeys = Object.keys(accountTypeInfo);
